// Infrastruktur- / Werkzeugmodule
import { mediator, timeoutRegistry, eventDebugger } from "./mediator/mediatorInstance.js";
import { registerRefactorHooks } from "./refactor/RefactorHooks";

// Legacy-Bridges
import { TopoLayoutConnector} from './legacy_bridge/TopoLayoutConnector.js';
import { TopoGlobalObjectsConnector } from './legacy_bridge/TopoGlobalObjectsConnector.js';

// Domänenspezifische Logik / Topothek-Module
import { Index } from './topoMapCore';
import { GoogleMapsAdapter } from './topoMapCore/adapter/GoogleMapsAdapter.js';
import { Legacy_TopoMarkers } from './topoMapCore/marker/legacy_TopoMarkers.js';
import { MarkerFactory} from './topoMapCore/factory/MarkerFactory.js';

// RefactorHooks aktivieren
registerRefactorHooks(mediator);

window.ModuleJS = {
    TopoMap: Index, GoogleMapsAdapter, TopoMarkers: Legacy_TopoMarkers, TopoMarkerFactory: MarkerFactory,
    TopoLayoutConnector, TopoGlobalObjectsConnector, Mediator: mediator
};